import WebsiteDemoVideoPIM from '../../Interfaces/PIMs/WebsiteDemoVideoPIM';
import { SD_SPNameList } from '../../Utility/StaticDatas';
import baseApi from '../baseApi';

const baseUrl = `/AuthDataGet/ExecuteJson/${SD_SPNameList.DB_SP_WebsiteVideo}`;

const SpWebsiteDemoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    insertWebsiteVideo: builder.mutation({
      query: (data: WebsiteDemoVideoPIM) => ({
        url: `${baseUrl}/1`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['WebsiteVideo'],
    }),

    deleteWebsiteVideo: builder.mutation({
      query: (data: WebsiteDemoVideoPIM) => ({
        url: `${baseUrl}/3`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['WebsiteVideo'],
    }),
    getAllWebsiteVideo: builder.query({
      query: () => ({
        url: `${baseUrl}/4`,
        method: 'POST',
        body: {},
      }),
      providesTags: ['WebsiteVideo'],
    }),
    getWebsiteVideoById: builder.query({
      query: (data: WebsiteDemoVideoPIM) => ({
        url: `${baseUrl}/5`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['WebsiteVideo'],
    }),
    toggleIsActiveWebsiteVideo: builder.mutation({
      query: (data: WebsiteDemoVideoPIM) => ({
        url: `${baseUrl}/7`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['WebsiteVideo'],
    }),

    getAllEncryptedVideoUrl: builder.query({
      query: () => ({
        url: `${baseUrl}/9`,
        method: 'POST',
        body: {},
      }),
      providesTags: ['WebsiteVideo'],
    }),
  }),
});

export const {
  useInsertWebsiteVideoMutation,
  useGetAllWebsiteVideoQuery,
  useDeleteWebsiteVideoMutation,
  useGetWebsiteVideoByIdQuery,
  useToggleIsActiveWebsiteVideoMutation,
  useGetAllEncryptedVideoUrlQuery,
} = SpWebsiteDemoApi;
export default SpWebsiteDemoApi;
